/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Locations API
 * AV Services Locations management API
 * OpenAPI spec version: 1.0
 */

export type LocationsSummariesControllerLocationsSummariesV1PathParameters = {
  clientId?: string;
};
